import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { IntegrationCodePiece } from '@/features/equipmentModels/types/equipmentModelIntegrationCode'
import { ImageOffIcon } from 'lucide-react'

interface PieceCardProps {
  piece: IntegrationCodePiece
}

const PieceCard = ({ piece }: PieceCardProps) => {
  return (
    <div className="flex w-full gap-2 min-w-0 p-4 bg-white-200 rounded">
      <ImageWithPlaceholder
        className="size-16 rounded-sm bg-white-400"
        url={piece.images[0]?.url}
        placeholderIcon={ImageOffIcon}
        iconClassName="size-12"
        placeholderIconProps={{ strokeWidth: 2 }}
      />

      <div className="flex w-full flex-col gap-2">
        <p className="text-sm font-bold break-words">{piece.display_name}</p>

        <div className="flex flex-wrap gap-x-4 gap-y-1">
          <div className="flex flex-col gap-1 min-w-0">
            <p className="text-[10px] italic font-light leading-3 text-white-800">Código da Peça</p>

            <p className="text-xs font-bold break-words">{piece.number}</p>
          </div>

          <div className="flex flex-col gap-1 min-w-0">
            <p className="text-[10px] italic font-light leading-3 text-white-800">Fabricante</p>

            <p className="text-xs font-bold break-words">{piece.brand.display_name}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PieceCard
